const ServiceType = (props) => {
  return (
    <h1>sds</h1>
  )
}

export default ServiceType;